import { NextImage } from '@apeiron/temp'
import { ButtonBase, styled, Typography } from '@mui/material'
import ApeironYouLabel from '@src/components/share/apeiron/ApeironYouLabel'
import { Guild } from '@src/types/guild'
import { FC, useCallback } from 'react'

const YouLabel = styled(ApeironYouLabel)`
  position: absolute;
`

const Container = styled(ButtonBase)<ContainerProps>`
  align-items: center;
  background-color: #191a1c;
  border-radius: 4px;
  display: flex;
  flex-direction: column;
  gap: 10px;
  height: 105px;
  justify-content: flex-start;
  overflow: hidden;
  padding: 12px;
  width: 200px;
  ${props => {
    if (props.__joined) {
      return `
        border: 2px solid #267ff8;
        background-color: #20344d;
      `
    }

    if (props.__selected) {
      return 'border: 2px solid #2ed104;'
    }
  }}
`

const Icon = styled(NextImage)`
  aspect-ratio: 1;
  width: 50px;
`

const Title = styled(Typography)`
  font-size: 14px;
  font-weight: 300;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
  width: 100%;
`

const GuildCard: FC<Props> = (props: Props) => {
  const { className, guild, joined, selected, onClick } = props

  const handleOnClick = useCallback(() => {
    if (onClick) {
      onClick(guild)
    }
  }, [guild, onClick])

  return (
    <Container
      className={className}
      onClick={handleOnClick}
      __joined={joined}
      __selected={selected}
    >
      <Icon src={guild.icon} />
      <Title>{guild.name}</Title>
      {joined && <YouLabel />}
    </Container>
  )
}

type ContainerProps = {
  __joined: boolean
  __selected: boolean
}

type Props = {
  className?: string
  guild: Guild
  joined: boolean
  selected: boolean
  onClick?: (guild: Guild) => void
}

export default GuildCard
